import { Observable } from 'rxjs';
import { IUserProfile } from '@app/core/models/user-profile.interface';

export abstract class IIdentityService {
  public abstract getUserProfile(): Observable<IUserProfile>;
}
